import { useQuery } from '@tanstack/react-query';

import { fetchData } from '../index';

export const GET_SMS_TEMPLATES = 'api/sms-marketing/get-templates';

export type SMSTemplate = {
  Label: string;
  TemplateId: string;
};

export function useGetSMSTemplatesQuery(leafbuyerSmsMarketingConfigId: number | null) {
  return useQuery({
    queryKey: ['smsTemplates', leafbuyerSmsMarketingConfigId],
    queryFn: () =>
      fetchData<SMSTemplate[]>(GET_SMS_TEMPLATES, {
        LeafbuyerSmsMarketingConfigId: leafbuyerSmsMarketingConfigId,
      }),
    enabled: !!leafbuyerSmsMarketingConfigId,
    staleTime: Infinity,
    cacheTime: 1000 * 60 * 60,
  });
}
